module.exports = __webpack_public_path__ + "img/Otp-guide-screen-4.ba8b5bbc.png";